import * as React from "react";
import {
    Card, CardHeader, CardText, CardBody, Modal, ModalHeader, ModalFooter, Button, ModalBody, Row, Col
} from 'reactstrap';
import { I18n } from "../../utils/I18n";
import { EditIcon, ViewIcon } from "../../utils/Icons";
import { cloneDeep, set } from "lodash-es";
import { ClaseMateriaService } from "../materia/ClaseMateriaService";
import { Loading } from "../../utils/Loading";
import { MatriculaListItemPaginatedList, MatriculaListItem } from "../../models/dataModels";
import { Link } from "react-router-dom";
import { RouteHelper } from "../../IntranetRouter";
import { UsuarioEditTabs } from "../../colegioUsuarios/Edit";
import { MatriculasService } from "../../matriculas/MatriculasService";
import { ClientContext } from "../../utils/ClientContext";
import { logAndExtractInfoFromException } from "../../utils/ValuesFormatter";

class MatriculasState {
    public loading: boolean;
    public showModal: boolean;
    public items: MatriculaListItem[];
}

class MatriculasProps {
    public numMatriculas: number;
    public claseMateriaId: number;
    public claseId: number;
}

export class Matriculas extends React.Component<MatriculasProps, MatriculasState> {

    public constructor(props: any) {
        super(props);

        this.state = {
            loading: false,
            showModal: false,
            items: null,
        };
    }

    public render(): JSX.Element {

        return (
            <div>
                {this.state.loading && <Loading />}
                {this.renderPopUp()}
                {I18n.Strings.cursoEscolar.numeroMatriculas(this.props.numMatriculas)}
                <a href="javaScript:void(0)"
                    title={"ver listado"}
                    className={"btn-niveles btn-borrarnivel"}
                    style={{ border: "none", marginLeft: "5px" }}
                    onClick={() => {
                        this.showModal();
                    }}>
                    <ViewIcon />
                </a>
            </div>
        );
    }

    protected showModal() {
        var state = this._cloneStateForSetState();
        state.loading = true;
        state.showModal = true;
        this.setState(state, () => {
            var service = new MatriculasService();
            service.getByClaseMateriaId(this.props.claseMateriaId, ClientContext.Current.cursoEscolarActivoId)
                .then(ret => {
                    this.setState({ loading: false, items: ret });
                })
                .catch((err) => {
                    this.setState({ loading: false, showModal: false }, () => {
                        alert(logAndExtractInfoFromException(err));
                    })
                });
        });
    }

    protected renderPopUp(): JSX.Element {
        return <Modal
            title={I18n.Strings.cursoEscolar.numeroMatriculas(this.props.numMatriculas)}
            isOpen={this.state.showModal}
            size="lg"
            toggle={() => { this.setState({ showModal: !this.state.showModal }) }}
        >
            {
                <ModalHeader close={<button className="btn-close" onClick={() => this.setState({ showModal: false })} />}>
                    {I18n.Strings.cursoEscolar.numeroMatriculas(this.props.numMatriculas)}
                </ModalHeader>
            }
            <ModalBody>
                {(this.state.items || []).length == 0 && <Row>
                    <p>No hay Matriculas</p>
                </Row>}

                {(this.state.items || []).length != 0 && <Row>
                    <Col md={12} className="notificaciones-items">
                        <div className="table-responsive">
                            <table className="table table-striped table-hover table-sm">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Usuario</th>
                                        <th>Rol</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.items.map((item, index) => {
                                        return <tr key={index}>
                                            <td>
                                                <Link to={RouteHelper.editUsuarioColegio(item.usuarioId, UsuarioEditTabs.Datos)}>
                                                    <EditIcon />
                                                </Link>
                                            </td>
                                            <td>
                                                {item.usuario}
                                            </td>
                                            <td>
                                                {item.rol}
                                            </td>
                                        </tr>;
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                </Row>}
            </ModalBody>
            <ModalFooter>
                <Button color="primary" size="lg" onClick={() => this.setState({ showModal: false })}>
                    {I18n.Strings.cancel}
                </Button>
            </ModalFooter>
        </Modal>;
    }

    protected _cloneStateForSetState(): MatriculasState {
        return cloneDeep(this.state) as MatriculasState;
    }
}